module.exports = __webpack_public_path__ + "img/menu_loyalty.93894dd9.svg";